import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ENDPOINT } from 'app/constants/endpoints.constant';
@Injectable({
  providedIn: 'root'
})
export class ModulosPaginasPermisosService {

  constructor(
    private http: HttpClient
  ) { }

  modulosPaginasPermisos(mPP): Observable<any> {
    return this.http.post<any>(`${ENDPOINT.msOtros.api}${ENDPOINT.msOtros.modulosPaginas}/list`, mPP);
  }
}
